module.exports = __webpack_public_path__ + "media/images/users/purchases/purchase_scatter_diagram-7533aa129d1a769b53b235c9bfa2a727.png";